<template>
  <div class="login">
    <div class="login__card ui-card">
      <div class="login__header">
        <router-link to="/" class="login__brand">
          <BrandLogo size="md" />
        </router-link>
        <h1 class="login__title">{{ judul }}</h1>
        <p class="login__subtitle">{{ keterangan }}</p>
      </div>

      <div v-if="pesan" class="login__alert" :class="{ 'is-baik': pesanBaik }" role="alert">
        <i :class="pesanBaik ? 'bi bi-check-circle' : 'bi bi-exclamation-circle'" aria-hidden="true"></i>
        <span>{{ pesan }}</span>
      </div>

      <!-- ── Langkah 1: surel atau kontingen ── -->
      <form v-if="langkah === 1" class="login__form" novalidate @submit.prevent="kirimKode">
        <div class="ui-field">
          <label for="lupa-identifier" class="ui-label">Email Akun atau Nama Kontingen</label>
          <input
            id="lupa-identifier"
            v-model.trim="identifier"
            type="text"
            class="ui-input"
            autocomplete="username"
            required
            placeholder="Contoh: official@gmail.com atau Garuda Sakti"
          />
          <p class="ui-label__hint">Masukkan email yang Anda gunakan saat mendaftar, atau nama kontingen Anda.</p>
        </div>

        <button type="submit" class="ui-btn ui-btn--primary ui-btn--lg ui-btn--block" :disabled="sibuk || !identifier">
          <span v-if="sibuk" class="ui-spinner" aria-hidden="true"></span>
          {{ sibuk ? 'Mengirim…' : 'Kirim Tautan & Kode Reset' }}
        </button>
      </form>

      <!-- ── Langkah 2: kode ── -->
      <form v-else-if="langkah === 2" class="login__form" novalidate @submit.prevent="periksaKode">
        <div class="ui-field">
          <label for="lupa-kode" class="ui-label">Kode 6 Angka</label>
          <input
            id="lupa-kode"
            v-model.trim="kode"
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="6"
            class="ui-input kode-input"
            required
            placeholder="000000"
          />
          <p class="ui-label__hint">Kode dan tautan reset telah dikirim ke {{ maskedEmail || email }} (berlaku 10 menit).</p>
        </div>

        <button type="submit" class="ui-btn ui-btn--primary ui-btn--lg ui-btn--block" :disabled="sibuk || kode.length !== 6">
          <span v-if="sibuk" class="ui-spinner" aria-hidden="true"></span>
          {{ sibuk ? 'Memeriksa…' : 'Lanjut' }}
        </button>

        <button
          type="button"
          class="ui-btn ui-btn--ghost ui-btn--block ui-btn--sm"
          :disabled="sibuk || jedaKirim > 0"
          @click="kirimKode"
        >
          {{ jedaKirim > 0 ? `Kirim ulang dalam ${jedaKirim} detik` : 'Kirim ulang kode' }}
        </button>
      </form>

      <!-- ── Langkah 3: sandi baru ── -->
      <form v-else class="login__form" novalidate @submit.prevent="gantiSandi">
        <div class="ui-field">
          <label for="lupa-sandi" class="ui-label">Kata Sandi Baru</label>
          <input
            id="lupa-sandi"
            v-model="sandi"
            type="password"
            class="ui-input"
            autocomplete="new-password"
            required
            placeholder="Minimal 8 karakter"
          />
          <p class="ui-label__hint">Minimal 8 karakter, harus memuat huruf dan angka.</p>
        </div>

        <div class="ui-field">
          <label for="lupa-sandi2" class="ui-label">Ulangi Kata Sandi</label>
          <input
            id="lupa-sandi2"
            v-model="sandi2"
            type="password"
            class="ui-input"
            autocomplete="new-password"
            required
            placeholder="Ketik ulang"
          />
        </div>

        <button type="submit" class="ui-btn ui-btn--primary ui-btn--lg ui-btn--block" :disabled="sibuk">
          <span v-if="sibuk" class="ui-spinner" aria-hidden="true"></span>
          {{ sibuk ? 'Menyimpan…' : 'Simpan Kata Sandi' }}
        </button>
      </form>

      <div class="login__footer">
        <router-link to="/admin/login" class="login__back">
          <i class="bi bi-arrow-left" aria-hidden="true"></i> Kembali ke halaman masuk
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/services/http';
import BrandLogo from '@/components/ui/BrandLogo.vue';

export default {
  name: 'LupaSandiPage',

  components: { BrandLogo },

  data() {
    return {
      langkah: 1,
      identifier: '',
      email: '',
      maskedEmail: '',
      kode: '',
      token: '',
      sandi: '',
      sandi2: '',
      sibuk: false,
      pesan: '',
      pesanBaik: false,
      jedaKirim: 0,
      pewaktu: null,
    };
  },

  computed: {
    judul() {
      return { 1: 'Lupa Kata Sandi', 2: 'Masukkan Kode', 3: 'Kata Sandi Baru' }[this.langkah];
    },
    keterangan() {
      return {
        1: 'Masukkan email akun atau nama kontingen Anda. Kami akan mengirimkan tautan dan kode reset kata sandi.',
        2: 'Buka email Anda, lalu klik tautan reset di email atau ketik enam digit angka yang diterima.',
        3: 'Buat kata sandi baru untuk akun Anda.',
      }[this.langkah];
    },
  },

  mounted() {
    // Jika official membuka tautan langsung dari surel: ?email=...&kode=...
    const emailQuery = this.$route.query.email;
    const kodeQuery = this.$route.query.kode;
    if (emailQuery && kodeQuery) {
      this.email = emailQuery;
      this.identifier = emailQuery;
      this.kode = kodeQuery;
      this.periksaKode();
    } else if (emailQuery) {
      this.email = emailQuery;
      this.identifier = emailQuery;
    }
  },

  beforeUnmount() {
    if (this.pewaktu) clearInterval(this.pewaktu);
  },

  methods: {
    mulaiJeda() {
      this.jedaKirim = 60;
      if (this.pewaktu) clearInterval(this.pewaktu);
      this.pewaktu = setInterval(() => {
        this.jedaKirim -= 1;
        if (this.jedaKirim <= 0) clearInterval(this.pewaktu);
      }, 1000);
    },

    async kirimKode() {
      if (!this.identifier) return;
      this.sibuk = true;
      this.pesan = '';
      try {
        const { data } = await http.post('/pemulihan/kirim-kode', {
          identifier: this.identifier,
          email: this.identifier,
          diamDiam: true,
        });
        if (data.email) {
          this.email = data.email;
        }
        if (data.masked_email) {
          this.maskedEmail = data.masked_email;
        }
        this.pesan = data.message;
        this.pesanBaik = true;
        this.langkah = 2;
        this.mulaiJeda();
      } catch (error) {
        this.pesan = error.friendlyMessage || 'Gagal mengirim kode.';
        this.pesanBaik = false;
      } finally {
        this.sibuk = false;
      }
    },

    async periksaKode() {
      this.sibuk = true;
      this.pesan = '';
      try {
        const { data } = await http.post('/pemulihan/periksa-kode', {
          email: this.email,
          kode: this.kode,
          diamDiam: true,
        });
        this.token = data.token;
        this.langkah = 3;
        this.pesan = '';
      } catch (error) {
        this.pesan = error.friendlyMessage || 'Kode salah atau sudah kedaluwarsa.';
        this.pesanBaik = false;
      } finally {
        this.sibuk = false;
      }
    },

    async gantiSandi() {
      if (this.sandi !== this.sandi2) {
        this.pesan = 'Kedua kata sandi belum sama.';
        this.pesanBaik = false;
        return;
      }

      this.sibuk = true;
      this.pesan = '';
      try {
        await http.post('/pemulihan/ganti-sandi', {
          email: this.email,
          token: this.token,
          password: this.sandi,
          password_confirmation: this.sandi2,
          diamDiam: true,
        });
        this.$router.push({ path: '/admin/login', query: { pulih: '1' } });
      } catch (error) {
        this.pesan = error.friendlyMessage
          || (error.validationErrors && Object.values(error.validationErrors)[0])
          || 'Gagal mengganti kata sandi.';
        this.pesanBaik = false;
      } finally {
        this.sibuk = false;
      }
    },
  },
};
</script>

<style scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: var(--space-5);
  background-color: var(--bg-base);
}

.login__card { width: 100%; max-width: 440px; padding: var(--space-8); box-shadow: var(--shadow-xl); }
.login__header { text-align: center; margin-bottom: var(--space-8); }
.login__brand { display: inline-block; margin-bottom: var(--space-5); }
.login__title { font-size: var(--text-2xl); margin: 0 0 var(--space-2); }
.login__subtitle { margin: 0; color: var(--text-secondary); font-size: var(--text-sm); }
.login__form { display: flex; flex-direction: column; gap: var(--space-5); }

.login__alert {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
  padding: var(--space-3) var(--space-4);
  font-size: var(--text-sm);
  border-radius: var(--radius-md);
  background: rgb(220 38 38 / 0.10);
  color: var(--danger-600);
}

.login__alert.is-baik { background: rgb(22 163 74 / 0.10); color: var(--success-500); }

/* Kode ditulis renggang dan besar: enam angka yang disalin dari surel
   lebih mudah dicek ulang kalau tidak berdempetan. */
.kode-input {
  font-size: var(--text-2xl);
  letter-spacing: 0.5em;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.login__footer { margin-top: var(--space-6); text-align: center; }
.login__back { font-size: var(--text-sm); color: var(--text-secondary); text-decoration: none; }
.login__back:hover { color: var(--text-brand); }
</style>
